module.exports = {
      id: "hamburger-youtube-usage",
      viewBox: "0 0 36 37",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#hamburger-youtube",
      toString: function () {
        return this.url;
      }
    }